import http from '../http'
import * as types from '../mutation-types';

export const state = {
    status: '',
    graduations: null,
};

export const getters = {
    loadStatus: state => state.status,
    graduations: state => state.graduations
};

export const mutations = {
    /** LOAD */
    [types.LOAD_GRADUATIONS_LOADING](state) {
        state.status = 'loading'
    },
    [types.LOAD_GRADUATIONS_SUCCESS](state, {data, meta}) {
        state.status = 'success'
        state.graduations = data
    },
    [types.LOAD_GRADUATIONS_ERROR](state) {
        state.status = 'error'
    }
};

export const actions = {
    load({commit}) {
        return new Promise((resolve, reject) => {
            commit(types.LOAD_GRADUATIONS_LOADING);
            http.get('graduations').then(({data}) => {
                commit(types.LOAD_GRADUATIONS_SUCCESS, {data: data.member || data, meta: data})
                resolve(data)
            }).catch(({response}) => {
                commit(types.LOAD_GRADUATIONS_ERROR)
                reject(response.data)
            })
        })
    }
};
